module.exports = __webpack_public_path__ + "static/image/history/pc/201303@3x.jpg?2cc5bdb7";